export default "__VITE_ASSET__BFtoL9Di__"